import script from "./WorkflowDeleteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowDeleteModal.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowDeleteModal.vue?vue&type=style&index=0&id=2168d58b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2168d58b"]])

export default __exports__